export default __webpack_public_path__ + "b6ca54fece47d06dc7e3d3c2e120c86b.svg";